'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getSafeReg = require('get-safe-reg');

var _getSafeReg2 = _interopRequireDefault(_getSafeReg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getRegString = function getRegString(name) {
  return '(?:^|\\s+)' + (0, _getSafeReg2.default)(name) + '(?:\\s+|$)';
};

var cache = (0, _getSafeReg.cacheReg)({})(getRegString);

exports.default = function (name) {
  return cache(name);
};

module.exports = exports['default'];